import LabRepository from "./LabRepository";
import { generateUrl } from "@/shared/utils";

const resource = "/laboratory";

export default {
  getAll(params) {
    return LabRepository.get(`${resource}?limit=all`, { params });
  },
  get(id, params) {
    return LabRepository.get(`${resource}/${id}`, { params });
  },
  getSome(params) {
    return LabRepository.get(`${resource}${generateUrl(params)}`);
  },
  create(payload) {
    return LabRepository.post(resource, payload);
  },
  update(id, payload) {
    return LabRepository.put(`${resource}/${id}`, payload);
  },
  suspend(id) {
    return LabRepository.delete(`${resource}/${id}`);
  },
  deleteBatch(payload) {
    return LabRepository.delete(resource, { data: { id: payload } });
  },
  getServiceQuestions(id) {
    return LabRepository.get(`${resource}/${id}/service-questions`);
  },
  getServiceQuestionsByType(id, sample_type_id, form_level) {
    sample_type_id =
      typeof sample_type_id !== "undefined" ? sample_type_id : null;
    return LabRepository.get(
      `${resource}/${id}/service-questions/${sample_type_id}/${form_level}`
    );
  },
  getTestPackages(id) {
    return LabRepository.get(`${resource}/${id}/test-packages`);
  },
  sortTestPackages(id, arr) {
    return LabRepository.put(`${resource}/${id}/test-packages/sort`, {
      sort: arr,
    });
  },
  sortTestPackageGroups(id, arr) {
    return LabRepository.put(`${resource}/${id}/test-package-groups/sort`, {
      sort: arr,
    });
  },
};
